import { createFileRoute, Navigate } from '@tanstack/react-router'
import ResetPasswordPage from 'pages/reset-password/ResetPasswordPage'
import { useIsLoggedIn } from 'hooks/useIsLoggedIn'

export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordRoute,
})

function ResetPasswordRoute() {
  const isLoggedIn = useIsLoggedIn()

  if (isLoggedIn) {
    return <Navigate to="/app" />
  }

  return <ResetPasswordPage />
}
